import React from 'react'
import { getImages } from '../Const'
import DefineStyle from './DefineStyle'
import { Formik, Form, Field } from 'formik';

const ListFormField = ({
    fieldName, values, handleDefineStyle,
    visibleBox, setFieldStyle, closeDefineStyle, setFieldValue, textLabel, hideInputField, maxLength
}) => {
    return (
        <>
            <li>
                <div className="d-flex align-items-center">
                    <div>
                        <label className="custom-checkbox ab-checkbox">
                            <Field
                                type="checkbox"
                                name={`${fieldName}.enabled`}
                                id={fieldName}
                            />
                            <label htmlFor={fieldName}>{textLabel}</label>
                        </label>
                    </div>
                    <div className="ms-auto">
                        {!hideInputField &&
                            <Field
                                type="text"
                                name={`${fieldName}.value`}
                                className="form-control"
                                disabled={!values[fieldName].enabled}
                                maxLength={maxLength}
                            />
                        }
                    </div>
                    <div>
                        <div className="position-relative ms-2">
                            {!hideInputField &&
                                <button type="button" className="ab-move-btn" onClick={() => handleDefineStyle(fieldName)}>
                                    <img src={getImages('bars.png')} />
                                </button>
                            }
                            {visibleBox === fieldName && (
                                <div className="edit-box define-style-box">
                                    <DefineStyle
                                        close={closeDefineStyle}
                                        fieldName={fieldName}
                                        currentStyle={{
                                            fontSize: values[fieldName].fontSize,
                                            color: values[fieldName].color,
                                        }}
                                        setFieldStyle={setFieldStyle}
                                        setFieldValue={setFieldValue}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </li>
        </>
    )
}

export default ListFormField